import request from "@/utils/request";
// 质量上报
export function qualityDetailList(query) {
  return request({
    url: "/ntocc-tms-api/creditQuality",
    method: "get",
    params: query
  });
}
export function orderDetailList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail",
    method: "get",
    params: query
  });
}

// 子公司运单管理
export function querySubList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/querySubList",
    method: "get",
    params: query
  });
}

export function batchSigned(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/batchSigned",
    method: "put",
    data: data
  });
}

export function noFeeList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/noFeeList",
    method: "get",
    params: query
  });
}
export function shanDongList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/shanDongList",
    method: "get",
    params: query
  });
}
export function hubeiList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/hubeiList",
    method: "get",
    params: query
  });
}
export function tianJinList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/tianJinList",
    method: "get",
    params: query
  });
}
export function reportMark(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/reportMark",
    method: "put",
    params: query
  });
}
export function listForFundFlow(query) {
  return request({
    url: "/ntocc-tms-api/remitDefinite/listForFundFlow",
    method: "get",
    params: query
  });
}
export function splitOrderList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/splitOrder",
    method: "get",
    params: query
  });
}
// 查询司机没有绑定银行卡
export function bankPartyCode(query) {
  // return request({
  //   url: `/ntocc-basic-api/bankCard/partyCode/${code}/pay`,
  //   method: 'get',
  // })
  return request({
    url: `ntocc-basic-api/bankCard/checkDriverBankCard`,
    method: "get",
    params: query
  });
}
//校验司机默认银行卡是否存在，含彩虹糖逻辑
export function checkDriverBankCard(partyCode, orderDetailCodes) {
  return request({
    url: `/ntocc-basic-api/bankCard/checkDriverBankCard`,
    method: "get",
    params: { partyCode: partyCode, orderDetailCodes: orderDetailCodes }
  });
}
// 银行预付
export function cashAdvanceBank(query) {
  return request({
    url: "/ntocc-tms-api/payAdvance/cashAdvance",
    method: "post",
    data: query
  });
}
export function batchCashPayment(query) {
  return request({
    url: `/ntocc-tms-api/finance/batchCashPayment`,
    method: "post",
    data: query
  });
}

// batchAlipayPayment
export function batchAlipayPayment(query) {
  return request({
    url: `/ntocc-tms-api/finance/batchAlipayPayment`,
    method: "post",
    data: query
  });
}

// 集中支付银行预付
export function centralPrepayment(query) {
  return request({
    url: `/ntocc-tms-api/centralizedPayment/centralPrepayment`,
    method: "post",
    data: query
  });
}
// 托运人预付中台预付
export function shipperPrePayment(query) {
  return request({
    url: `/ntocc-tms-api/payAdvance/shipperPrePayment`,
    method: "post",
    params: query
  });
}
// 托运人预付
export function shipperPrepaidConfirm(query) {
  return request({
    url: `/ntocc-tms-api/payAdvance/shipperPrepaidConfirm`,
    method: "post",
    params: query
  });
}
// 托运人预付获取验证码
export function getVerificationCodeShipperPrepaid(query) {
  return request({
    url: `/ntocc-tms-api/mybankBalancePay/getVerificationCodeShipperPrepaid`,
    method: "put",
    params: query
  });
}
// 集中支付更新预付状态
export function queryPayAdvanceStatus(query) {
  return request({
    url: `/ntocc-tms-api/centralizedPayment/queryPayAdvanceStatus`,
    method: "put",
    params: query
  });
}
// 集中支付重新支付
export function centralPrepaymentAgain(query) {
  return request({
    url: `/ntocc-tms-api/centralizedPayment/centralPrepaymentAgain`,
    method: "put",
    params: query
  });
}
export function orderDetailfill(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/fill",
    method: "put",
    params: data
  });
}
export function uploadTicketImage(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/uploadTicketImage",
    method: "put",
    params: data
  });
}
export function CancellationOrder(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/driverCancelOrder",
    method: "put",
    params: data
  });
}
export function orderAbnormal(data) {
  return request({
    url: "/ntocc-basic-api/orderDetailAbnormal",
    method: "post",
    params: data
  });
}
// tms/pushWaybillToMqttByOrderCode
export function pushWaybillToMqttByOrderCode(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/pushWaybillToMqttByOrderCode",
    method: "post",
    params: data
  });
}
export function deleteDetail(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail`,
    method: "delete",
    params: data
  });
}
export function deleteAbnormalOrderDetail(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/deleteAbnormalOrderDetail`,
    method: "delete",
    params: {
      codes: data
    }
  });
}
export function extraAddOrderDetail(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/extraAddOrderDetail",
    method: "put",
    params: data
  });
}
export function OrderDetails(code) {
  return request({
    url: `/ntocc-tms-api/orderDetail/${code}`,
    method: "get"
  });
}
// 银行卡支付
export function payverifyPayee(query) {
  return request({
    url: `/ntocc-tms-api/payAdvance/verifyPayee`,
    method: "get",
    params: query
  });
}
// 更新集中支付打款状态
export function centralQueryPaymentResult(query) {
  return request({
    url: `/ntocc-tms-api/centralizedPayment/centralQueryPaymentResult`,
    method: "put",
    params: query
  });
}
export function vehicle(query) {
  return request({
    url: "/ntocc-basic-api/vehicle",
    method: "get",
    params: query
  });
}

export function deleteVehicle(query) {
  return request({
    url: "/ntocc-basic-api/vehicle",
    method: "delete",
    params: query
  });
}
export function readOfflinePolicy(query) {
  return request({
    url: "/ntocc-basic-api/openInsure/readOfflinePolicy",
    method: "get",
    params: query
  });
}
// 选择车队
export function showDriverTeamList(query) {
  return request({
    url: "/ntocc-basic-api/driver/showDriverTeamList",
    method: "get",
    params: query
  });
}
export function reportTransportWaybill(data) {
  return request({
    url: "/ntocc-basic-api/report/reportTransportWaybill",
    method: "post",
    params: data
  });
}

export function reportHubeiTransportWaybill(data) {
  return request({
    url: "/ntocc-thirdparty-api/huBeiApi/reportTransportWaybill",
    method: "post",
    params: data
  });
}
export function reportTianjinTransportWaybill(data) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportTransportWaybill",
    method: "post",
    params: data
  });
}
export function reportTransportFund(data) {
  return request({
    url: "/ntocc-basic-api/report/reportTransportFund",
    method: "post",
    params: data
  });
}
export function reportHubeiTransportFund(data) {
  return request({
    url: "/ntocc-thirdparty-api/huBeiApi/reportTransportFund",
    method: "post",
    params: data
  });
}
export function reportTianjinTransportFund(data) {
  return request({
    url: "/ntocc-thirdparty-api/tianJinApi/reportTransportFund",
    method: "post",
    params: data
  });
}
export function rejectOrderDetail(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/rejectOrderDetail",
    method: "put",
    params: data
  });
}
export function orderHandle(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderHandle",
    method: "put",
    params: data
  });
}
export function calculateOrderDetailPC(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/calculateOrderDetailPC",
    method: "put",
    params: {
      codes: data
    }
  });
}
export function driverListOrder(query) {
  return request({
    url: "/ntocc-basic-api/driverCancelOrder",
    method: "get",
    params: query
  });
}
// 其他费用
export function OrderExtraFee(query) {
  return request({
    url: "/ntocc-tms-api/orderExtraFee",
    method: "get",
    params: query
  });
}
export function AbnormalList(query) {
  return request({
    url: "/ntocc-basic-api/orderDetailAbnormal",
    method: "get",
    params: query
  });
}
export function handleAbnormal(query) {
  return request({
    url: "/ntocc-basic-api/orderDetailAbnormal/handle",
    method: "post",
    params: query
  });
}
export function orderDetailHandlePageList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderDetailHandlePageList",
    method: "get",
    params: query
  });
}

export function queryReviewOrderList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/queryReviewOrderList",
    method: "get",
    params: query
  });
}

export function orderHandlePC(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderHandlePC",
    method: "put",
    params: query
  });
}
export function calculateOrderDetail(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/calculateOrderDetail",
    method: "put",
    data
  });
}
export function orderHandleEditSubmit(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderHandleEditSubmit",
    method: "put",
    params: data
  });
}

export function orderHandleEditSubmitAndSave(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderHandleEditSubmitHandle",
    method: "put",
    params: data
  });
}

export function orderDetailInfoLoadAndUnloadConfirm(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderDetailInfoLoadAndUnloadConfirm",
    method: "get",
    params: {
      code: query
    }
  });
}
export function shipperConfirmUnLoading(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/shipperConfirmUnLoading",
    method: "put",
    params: data
  });
}
export function shipperConfirmLoading(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/shipperConfirmLoading",
    method: "put",
    params: data
  });
}
export function applicationForPayment(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/applicationForPayment",
    method: "put",
    params: {
      codes: data
    }
  });
}
// 分配油点
export function Oilpoint(data) {
  return request({
    url: "/ntocc-tms-api/finance/singleOil",
    method: "post",
    params: data
  });
}
// 单笔打款
export function CashPayment(data) {
  return request({
    url: "/ntocc-tms-api/finance/singlePayment",
    method: "post",
    data
  });
}

export function remitDefinite(query) {
  return request({
    url: "/ntocc-tms-api/remitDefinite",
    method: "get",
    params: query
  });
}

export function orderDetailFinish(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderDetailFinish",
    method: "put",
    params: data
  });
}

export function updateWeightAndRecalculateFee(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/updateWeightAndRecalculateFee",
    method: "post",
    data
  });
}

// 托运人打款 驳回
export function financeReject(data) {
  return request({
    url: `/ntocc-tms-api/finance/reject`,
    method: "put",
    params: data
  });
}
// 批量打款
export function batchPayment(data) {
  return request({
    url: "/ntocc-tms-api/finance/batchPayment",
    method: "post",
    params: data
  });
}

// 回单签收
export function detailReceiptReturn(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/detailPaperReturns`,
    method: "put",
    params: data
  });
}

// 回单签收New
export function deliverReceiptSigned(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/deliverReceiptSigned`,
    method: "put",
    data: data
  });
}
//上报信用质量
export function reportCreditQuality(data) {
  return request({
    url: `/ntocc-basic-api/creditQuality/reportCreditQuality`,
    method: "put",
    params: data
  });
}

//上报合同
export function reportContractInfo(data) {
  return request({
    url: `/ntocc-basic-api/report/reportContractInfo`,
    method: "put",
    params: data
  });
}

//上报合同
export function createContractAgain(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/createContractAgain`,
    method: "put",
    params: data
  });
}
//批量下载合同
export function downLoadFile(data) {
  return request({
    url: `/ntocc-basic-api/orderDetailContract/downLoadFile`,
    method: "get",
    params: data
  });
}

//
export function recoverDeletedOrder(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/recoverDeletedOrder`,
    method: "get",
    params: data
  });
}

//重新生成货源合同
export function createOrderContractAgain(data) {
  return request({
    url: `/ntocc-basic-api/orderDetailContract/createOrderContractAgain`,
    method: "put",
    params: data
  });
}
export function orderDetailListTax(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/listTax",
    method: "get",
    params: query
  });
}
// 装货位置上报
export function reportOrderDetailLocation(query) {
  return request({
    url: "/ntocc-basic-api/report/reportOrderDetailLocationForSiChuan",
    method: "put",
    params: query
  });
}
// 失信车辆上报  /report/reportDishonestyVehicle
export function reportDishonestyVehicle(query) {
  return request({
    url: "/ntocc-basic-api/report/reportDishonestyVehicle",
    method: "put",
    params: query
  });
}

// 财务打款 驳回并退款
export function financeRejectAndRefund(data) {
  return request({
    url: `/ntocc-tms-api/finance/rejectAndRefund`,
    method: "put",
    params: data
  });
}

// 财务打款 开票申请
export function billingApplication(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/billingApplication`,
    method: "post",
    params: data
  });
}

export function erejectAndRefundQuery(query) {
  return request({
    url: `/ntocc-tms-api/finance/erejectAndRefundQuery`,
    method: "post",
    params: query
  });
}

// 路单上报修改
export function verifyAPPLocationStatus(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/verifyAPPLocationStatus",
    method: "get",
    params: query
  });
}
// 获取当前登录用户所属机构的默认公户信息
export function loginUserDefaultHousehold(query) {
  return request({
    url: `/ntocc-basic-api/platformHousehold/defaultHouseholdByBranchAndType`,
    method: "get",
    params: query
  });
}

// add by JiaYK start 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
export function isOpenMaYi(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/isOpen",
    method: "get",
    params: query
  });
}
// add by JiaYK end 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
export function queryPaymentResult(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/queryPaymentResult",
    method: "post",
    params: query
  });
}

// 云企付 获取在中台配置的手机号
export function getConfigPhone(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/getConfigPhone",
    method: "post",
    params: query
  });
}
// 发送短信验证码
export function sendVerificationCode(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/sendVerificationCode",
    method: "post",
    params: query
  });
}

// 发送短信验证码（通联）
export function sendVerificationCodeTL(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/payToDriverTL",
    method: "post",
    params: query
  });
}

// 在线支付
export function prepayToDriver(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/prepayToDriver",
    method: "post",
    params: query
  });
}

// 在线支付
export function payToDriver(data) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/payToDriver",
    method: "post",
    params: data
  });
}

// 在线支付（通联）
export function payByBackSMS(data) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/payByBackSMS",
    method: "post",
    params: data
  });
}

// 更新状态
export function queryPayToDriverResult(query) {
  return request({
    url: `/ntocc-tms-api/arpaTransfer/queryPayToDriverResult`,
    method: "post",
    params: query
  });
}

//在线支付批量接口
export function batchPayToDriver(query) {
  return request({
    url: `/ntocc-tms-api/arpaTransfer/batchPayToDriver`,
    method: "post",
    params: query
  });
}
// 路单上报记录
export function orderReportRecord(query) {
  return request({
    url: `/ntocc-tms-api/orderReportRecord`,
    method: "get",
    params: query
  });
}

// 财务打款判断开票确认状态-金昌
export function verifyBillingConfirmationStatus(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/verifyBillingConfirmationStatus",
    method: "get",
    params: query
  });
}
// 财务打款判断开票确认状态-金昌
export function branchBalanceStatistics(query) {
  return request({
    url: "/ntocc-basic-api/party/branchBalanceStatistics",
    method: "get",
    params: query
  });
}

export function orderBatchDetailFinish(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/orderBatchDetailFinish",
    method: "post",
    data: data
  });
}

export function orderDetailTrack(data) {
  return request({
    url: `/ntocc-tps-api/vehicleMap/vHisTrackDel`,
    method: "get",
    params: {
      orderCode: data
    }
  });
}

export function listByHBYD(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/listByHB",
    method: "get",
    params: query
  });
}

export function queryAbnormalOrderList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/queryAbnormalOrderList",
    method: "get",
    params: query
  });
}

export function refreshFee(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/refreshFee",
    method: "put",
    params: query
  });
}

export function submitAppeal(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/submitAppeal",
    method: "post",
    data: data
  });
}

export function reopenAppeal(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/reopenAppeal",
    method: "post",
    params: query
  });
}

export function queryOrderAppealList(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/queryOrderAppealList",
    method: "get",
    params: query
  });
}

export function reviewAppeal(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/reviewAppeal",
    method: "post",
    data: data
  });
}

export function driverCancelReturnPay(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/driverCancelReturnPay",
    method: "put",
    params: data
  });
}

export function adCancelReturnPay(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/adCancelReturnPay",
    method: "put",
    params: data
  });
}

// 托运人修改回单付金额
export function shipperModifyReturnPayAmount(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/shipperModifyReturnPayAmount",
    method: "put",
    params: data
  });
}

export function getCancelReturnPayContent(query) {
  return request({
    url: `/ntocc-tms-api/orderDetail/getCancelReturnPayContent/${query.code}`,
    method: "get",
    params: query
  });
}

export function orderDetailListAll(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/listAll",
    method: "get",
    params: query
  });
}

// 预付，到付回单付子公司
// export function querySubList(query) {
//   return request({
//     url: "/ntocc-tms-api/orderDetail/querySubList",
//     method: "get",
//     params: query
//   });
// }

// 获取协议
export function getContractInfo(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/getContractInfo" + "?code=" + query.code,
    method: "get"
  });
}

// 获取五证信息
export function getIdentityDocumentInfo(query) {
  return request({
    url:
      "/ntocc-tms-api/orderDetail/getIdentityDocumentInfo" +
      "?code=" +
      query.code,
    method: "get"
  });
}

// 开票审核运单异常标记
export function saveOrUpdateInvoiceOrderDetailReview(data) {
  return request({
    url: "/ntocc-basic-api/invoiceOrderDetailReview/saveOrUpdate",
    method: "post",
    data
  });
}
